module.exports = __webpack_public_path__ + "static/img/order_upload.a772818.png";


//////////////////
// WEBPACK FOOTER
// ./static/order_upload.png
// module id = Mf2Z
// module chunks = 24